import { ApolloError } from '@apollo/client';
import { ERROR_UNAUTHORIZED } from '@constants/errors';

export function isUnauthorizedError(error: unknown) {
  return error instanceof ApolloError && error.message === ERROR_UNAUTHORIZED;
}
